import React, { FC } from 'react';
import { MenuData } from './Types/MenuAndSubmenu';
import { makeStyles } from '@material-ui/core/styles';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import TreeItem from '@material-ui/lab/TreeItem';
import TreeView from '@material-ui/lab/TreeView';
import { Checkbox, FormControlLabel, IconButton, Tooltip } from '@material-ui/core';
import { Info } from '@material-ui/icons';
import CustomSkeleton from 'src/components/skeleton/Skeleton';

interface MenuTreeProps {
  data: MenuData[];
  checkedList: string[];
  setCheckedList: any;
  isTreeLoading: boolean;
};

interface MenuItemProps {
  item: MenuData;
  checkedList: string[];
  setCheckedList: any;
};

const useStyles = makeStyles({
  root: {
    height: 300,
    flexGrow: 1
  }
});

const MenuItem: FC<MenuItemProps> = ({ item, checkedList, setCheckedList }) => {
  const isIndeterminate = () => {
    if (!item.submenus) return false;

    let checkedCount = 0;
    item.submenus.forEach(submenu => {
      if (checkedList.includes(submenu.id)) {
        checkedCount++;
      }
    });
    return checkedCount > 0 && checkedCount < item.submenus.length;
  };

  const shouldCheck = () => {
    if (item.submenus && item.submenus.length > 0) {
      if (item.submenus.every(submenu => checkedList.includes(submenu.id))) {
        return true;
      } else {
        return false;
      }
    } else {
      return checkedList.includes(item.id);
    }
  };


  const handleCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    event.stopPropagation();
    if (event.target.checked) {
      if (item.submenus && item.submenus.length > 0) {
        const listWithChildren = [item.id, ...item.submenus.map(x => x.id)];
        setCheckedList((prev) => [...prev, ...listWithChildren]);
      } else {
        setCheckedList((prev) => [...prev, item.id]);
      }
    } else {
      if (item.submenus && item.submenus.length > 0) {
        const idsToRemove = [item.id, ...item.submenus.map(x => x.id)];
        setCheckedList(checkedList.filter(x => !idsToRemove.includes(x)));
      } else {
        setCheckedList(checkedList.filter(x => x !== item.id));
      }
    }
  };

  return (
    <>
      <TreeItem
        nodeId={item.address}
        key={item.address}
        label={
          <>
            <FormControlLabel
              control={
                <Checkbox
                  checked={shouldCheck()}
                  indeterminate={isIndeterminate()}
                  onChange={handleCheckboxChange}
                />
              }
              label={item.name}
            />
            {item.address && (
              <IconButton sx={{ margin: '0', marginLeft: '1%', padding: '0' }}>
                <Tooltip title={item.address} placement="top">
                  <Info fontSize='small' />
                </Tooltip>
              </IconButton>
            )}
          </>
        }
      >
        {item.submenus && item.submenus.map((x, index) => (
          <MenuItem key={index} item={x} checkedList={checkedList} setCheckedList={setCheckedList} />
        ))}
      </TreeItem>
    </>
  );
};

const MenuTree: FC<MenuTreeProps> = ({ data, checkedList, setCheckedList, isTreeLoading }) => {
  const classes = useStyles();

  return (
    <div>
      {isTreeLoading && <CustomSkeleton skeletonType='TreeViewSkeleton' repeatSkeleton={5}/>}
      {!isTreeLoading && (
        <TreeView
          className={classes.root}
          defaultCollapseIcon={<ExpandMoreIcon />}
          defaultExpandIcon={<ChevronRightIcon />}
        >
         {data.map((item, index) => (
          <MenuItem item={item} key={index} checkedList={checkedList} setCheckedList={setCheckedList}/>
          ))}
        </TreeView>
      )}
    </div>
  );
};

export default MenuTree;
